/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export {
  WebSocketConnectionState,
  ConnectionTrigger,
  WebSocketObservableState,
  WebSocketFsmState,
  MrpcMessageType,
  TransportEventType,
  WebSocketErrorCode,
  WebSocketError
} from "./WebSocketTypes";

export type {
  IWebSocketMessage,
  ITransportOpenEvent,
  ITransportTextMessageEvent,
  ITransportBinaryMessageEvent,
  ITransportErrorEvent,
  ITransportClosedEvent,
  TransportEvent,
  TransportEventListener,
  WebSocketStateListener,
  OperationHandler,
  IWebSocketConfig,
  IOutboundBufferEntry
} from "./WebSocketTypes";
